import React, { useState } from 'react';
import axios from 'axios';
import { showError } from '../utils/alerts';
import { API_BASE_URL } from '../config';
import FechaSelector from '../components/FechaSelector';
import TablaBalance from '../components/TablaBalance';
import '../styles/pages/VerBalance.css';

const VerBalance = ({ token, id_company }) => {
  const [mes, setMes] = useState('');
  const [anual, setAnual] = useState('');
  const [balanceData, setBalanceData] = useState([]);
  // Período efectivamente consultado: el PDF debe corresponder a lo que se ve en pantalla,
  // no a lo que el selector tenga elegido en ese momento.
  const [periodoConsultado, setPeriodoConsultado] = useState(null);
  const [loadingPDF, setLoadingPDF] = useState(false);

  const handleDateChange = (selectedMes, selectedAnual) => {
    setMes(selectedMes);
    setAnual(selectedAnual);
  };

  const isMonthClosed = async (mes, anio) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/cierre-mensual`, {
        params: { company: id_company, anio },
        headers: { Authorization: `Bearer ${token}` },
      });
      const monthData = res.data.find((item) => item.mes === parseInt(mes, 10));
      return monthData ? monthData.cerrado : false;
    } catch (error) {
      console.error('Error al verificar cierre mensual:', error);
      return false;
    }
  };

  const handleBuscarBalance = async () => {
    if (!mes || !anual) {
      showError('Por favor selecciona un mes y un año');
      return;
    }

    const cerrado = await isMonthClosed(mes, anual);
    if (!cerrado) {
      showError('El mes seleccionado no está cerrado. Debes cerrar el mes primero para ver el balance.');
      return;
    }

    try {
      const balanceRes = await axios.get(`${API_BASE_URL}/api/buscar-balance`, {
        params: { mes, anual, id_company },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (balanceRes.data && balanceRes.data.length > 0) {
        setBalanceData(balanceRes.data);
        setPeriodoConsultado({ mes, anual });
      } else {
        setBalanceData([]);
        setPeriodoConsultado(null);
        showError('No se encontró el balance. Por favor, contacta al administrador.');
      }
    } catch (error) {
      console.error('Error al buscar balance:', error);
      showError(error.response?.data || 'Error al buscar balance');
    }
  };

  /**
   * Abre el PDF del balance del período. No se genera nada en el navegador:
   * el archivo es el mismo que queda guardado al generar el balance.
   */
  const handleDescargarPDF = async () => {
    if (!periodoConsultado) return;
    setLoadingPDF(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/balance/pdf`, {
        params: { ...periodoConsultado, id_company },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.url) {
        window.open(res.data.url, '_blank', 'noopener');
      } else {
        showError('No se pudo obtener el PDF del balance');
      }
    } catch (error) {
      console.error('Error al obtener el PDF del balance:', error);
      showError(error.response?.data?.error || 'Error al obtener el PDF del balance');
    } finally {
      setLoadingPDF(false);
    }
  };

  return (
    <div className="ver-balance">
      <h1>Ver Balance General</h1>
      <FechaSelector onDateChange={handleDateChange} />
      <button className="btn-ver-balance" onClick={handleBuscarBalance}>Ver Balance General</button>

      {periodoConsultado && (
        <div className="balance-export-actions">
          <button
            onClick={handleDescargarPDF}
            disabled={loadingPDF}
            className="btn-export btn-export-pdf"
          >
            {loadingPDF ? 'Obteniendo...' : 'Descargar PDF'}
          </button>
        </div>
      )}

      <TablaBalance data={balanceData} />
    </div>
  );
};

export default VerBalance;
